export const DEFAULT_QUESTION_OPTIONS = [
  { SerialNumber: 1, OptionText: "", IsCorrect: true },
  { SerialNumber: 2, OptionText: "", IsCorrect: false },
  { SerialNumber: 3, OptionText: "", IsCorrect: false },
  { SerialNumber: 4, OptionText: "", IsCorrect: false },
];

export function createEmptyQuestionDraft(id) {
  return {
    id: id || `q-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    questionText: "",
    options: DEFAULT_QUESTION_OPTIONS.map((o) => ({ ...o })),
  };
}

export function validateQuestionDraft(draft) {
  const errors = {};
  if (!draft.questionText?.trim()) {
    errors.questionText = "Question text is required.";
  }

  const filled = (draft.options || []).filter((o) => o.OptionText?.trim());
  if (filled.length < 2) errors.options = "At least two options are required.";
  if (filled.filter((o) => o.IsCorrect).length !== 1) {
    errors.correct = "Select exactly one correct option.";
  }

  return errors;
}

export function escapeXml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}

export function buildQuestionOptionsXml(options) {
  const items = options
    .filter((o) => o.OptionText.trim())
    .map((o, idx) => {
      const serial = idx + 1;
      const isCorrect = o.IsCorrect ? 1 : 0;
      return `<Option SerialNumber="${serial}" IsCorrect="${isCorrect}">${escapeXml(
        o.OptionText.trim(),
      )}</Option>`;
    })
    .join("");
  return `<Options>${items}</Options>`;
}

export function buildQuestionsBulkXml(questionDrafts) {
  const items = questionDrafts
    .map((draft) => {
      const options = (draft.options || []).filter((o) => o.OptionText?.trim());
      const optionsInner = options
        .map((o, idx) => {
          const serial = idx + 1;
          const isCorrect = o.IsCorrect ? 1 : 0;
          return `<Option SerialNumber="${serial}" IsCorrect="${isCorrect}">${escapeXml(
            o.OptionText.trim(),
          )}</Option>`;
        })
        .join("");
      return `<Question><Text>${escapeXml(
        draft.questionText.trim(),
      )}</Text><Options>${optionsInner}</Options></Question>`;
    })
    .join("");
  return `<Questions>${items}</Questions>`;
}
